<template>
  <div class="arrow-nav-container">
    <div class="home-tag" @click="handleGoToHome">首页</div>
    <img class="arrow" :src="imgArrow"/>
    <div class="text-tag" @click="handleGoToHome">{{text}}</div>
  </div>
</template>
<script>
  import ImgArrow from "@/assets/img/home/arrow.png"
  export default {
    name: "arrowNav",
    props: {
      text: { type: String, default: "" },
    },
    data() {
      return {
        imgArrow: ImgArrow,
      };
    },
    methods: {
      handleGoToHome() {
        let route = {
          name: 'home',
        }
        this.$router.push(route)
      }
    }
  };
</script>
<style scoped>
  .arrow-nav-container {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

    .arrow-nav-container .home-tag {
      font-family: Source Han Sans CN;
      font-weight: 400;
      font-size: 14px;
      color: #565656;
      line-height: 1;
      cursor: pointer;
    }

    .arrow-nav-container .arrow {
      width: 17px;
      height: 6px;
      margin-left: 0.5em;
      margin-right: 0.5em;
    }

    .arrow-nav-container .text-tag {
      font-family: Source Han Sans CN;
      font-weight: 400;
      font-size: 14px;
      color: #222222;
      line-height: 1;
    }
</style>




// WEBPACK FOOTER //
// src/components/arrow-nav/arrow-nav.vue